module.exports = __webpack_public_path__ + "img/pattern_header.7e4e0945.png";